import { AbstractControl, FormControl, ValidationErrors,ValidatorFn } from "@angular/forms";
import * as moment from "moment";
import { UploadService } from "../services/core/documents/upload.service";
import { imageProcessing } from "./image-processing-utils";
import * as XLSX from 'xlsx';

export function exportToExcel(filename:any, sheets:any) {
  // Create a new workbook
  var wb = XLSX.utils.book_new();

  // Iterate through the sheets object to add sheets to the workbook
  for (var sheetName in sheets) {
    if (sheets.hasOwnProperty(sheetName)) {
      var ws_data = sheets[sheetName];
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    }
  }

  // Write the workbook to a file
  var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

  // Create a Blob from the binary data
  var buf = new ArrayBuffer(wbout.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i < wbout.length; ++i) {
    view[i] = wbout.charCodeAt(i) & 0xFF;
  }
  var blob = new Blob([buf], { type: 'application/octet-stream' });

  // Create a link element and trigger a download
  var link = document.createElement("a");
  if (link.download !== undefined) { // feature detection
    var url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


}

export const timeZone = "America/New_York";

export const getBrokersList = {
    'default': 'Default',
    'amera': 'Amera',
    'abcinsurance': 'Abc Insurance',
    'americanLogistics': 'American Logistics',
    'arn': 'Angel Ride Network',
    'access2Ride': 'Access2Care',
    'callthecar': 'Call The Car',
    'caloptima': 'CalOptima',
    'epic': 'EPIC',
    'iehp': 'IEHP',
    'lcp': 'LCP',
    'logisticscare': 'Logisticare',
    'medex': 'Medex',
    'first': 'MTM',
    'mas': 'MAS',
    'medicaid': 'Medicaid',
    'modivcare': 'Modivcare',
    'medtrans': 'NMN',
    'onecall': 'One Call',
    'ride2md': 'Ride2MD',
    'united': 'Southeastrans',
    'saferide': 'Safe Ride',
    'tncarrier': 'Tennessee Carriers',
    'welltrans': 'Welltrans',
    'vapremier': 'Va Premier',
    'veyo': 'Veyo', 
    'providearide' : 'Provide A Ride',
    'wellmed' : 'WellMed',
  };

  export const getShiftDays = [
    { label: "Sun", day: 0 },
    { label: "Mon", day: 1 },
    { label: "Tue", day: 2 },
    { label: "Wed", day: 3 },
    { label: "Thu", day: 4 },
    { label: "Fri", day: 5 },
    { label: "Sat", day: 6 }
  ];

export const getstandingOrderDays = [
  { label: "monday", day: 1, checked: false },
  { label: "tuesday", day: 2, checked: false },
  { label: "wednesday", day: 3, checked: false },
  { label: "thursday", day: 4, checked: false },
  { label: "friday", day: 5, checked: false },
  { label: "saturday", day: 6, checked: false },
  { label: "sunday", day: 0, checked: false}
];

  
export const CAPACITY: any = ['1', '2', '3', '4', '5', '6', '7'];

export const FUELTYPES: any = [
  { value: "petrol", key: "Petrol" },
  { value: "diesel", key: "Diesel" },
  { value: "octane", key: "HighOctane" },
  { value: "hybrid", key: "Hybrid" },
  { value: "ev", key: "EV" }
];

export const BODYTYPES: any = [
  { value: "minicut", key: "Mini Cut" },
  { value: "fullcut", key: "Full Cut" }
];

export function getAddressDetails(locationData:any) {
  let address: any = {
    aptOrSuite:'',
    street: '',
    city: '',
    state: '',
    zipCode: ''
  };
  locationData.address_components.forEach((component:any) => {
    if (component.types.includes("street_number")) {
      address.street = component.long_name;
    } else if (component.types.includes("route")) {
      address.street = address.street ? address.street+" " + component.long_name : component.long_name;
    } else if (component.types.includes("subpremise")) {
      address.aptOrSuite = "#"+ component.long_name;
    }  else if (component.types.includes("locality")) {
      address.city = component.long_name;
    } else if (component.types.includes("administrative_area_level_1")) {
      address.state = component.short_name;
    } else if (component.types.includes("postal_code")) {
      address.zipCode = component.long_name;
    }
  });

  return address;
}

export const states = [
  { value: "AK", name: "Alaska" },
  { value: "AL", name: "Alabama" },
  { value: "AR", name: "Arkansas" },
  { value: "AZ", name: "Arizona" },
  { value: "CA", name: "California" },
  { value: "CO", name: "Colorado" },
  { value: "CT", name: "Connecticut" },
  { value: "DC", name: "DistrictofColumbia" },
  { value: "DE", name: "Delaware" },
  { value: "FL", name: "Florida" },
  { value: "GA", name: "Georgia" },
  { value: "HI", name: "Hawaii" },
  { value: "IA", name: "Iowa" },
  { value: "ID", name: "Idaho" },
  { value: "IL", name: "Illinois" },
  { value: "IN", name: "Indiana" },
  { value: "KS", name: "Kansas" },
  { value: "KY", name: "Kentucky" },
  { value: "LA", name: "Louisiana" },
  { value: "MA", name: "Massachusetts" },
  { value: "MD", name: "Maryland" },
  { value: "ME", name: "Maine" },
  { value: "MI", name: "Michigan" },
  { value: "MN", name: "Minnesota" },
  { value: "MO", name: "Missouri" },
  { value: "MS", name: "Mississippi" },
  { value: "MT", name: "Montana" },
  { value: "NC", name: "NorthCarolina" },
  { value: "ND", name: "NorthDakota" },
  { value: "NE", name: "Nebraska" },
  { value: "NH", name: "NewHampshire" },
  { value: "NJ", name: "NewJersey" },
  { value: "NM", name: "NewMexico" },
  { value: "NV", name: "Nevada" },
  { value: "NY", name: "NewYork" },
  { value: "OH", name: "Ohio" },
  { value: "OK", name: "Oklahoma" },
  { value: "OR", name: "Oregon" },
  { value: "PA", name: "Pennsylvania" },
  { value: "RI", name: "RhodeIsland" },
  { value: "SC", name: "SouthCarolina" },
  { value: "SD", name: "SouthDakota" },
  { value: "TN", name: "Tennessee" },
  { value: "TX", name: "Texas" },
  { value: "UT", name: "Utah" },
  { value: "VA", name: "Virginia" },
  { value: "VT", name: "Vermont" },
  { value: "WA", name: "Washington" },
  { value: "WI", name: "Wisconsin" },
  { value: "WV", name: "WestVirginia" },
  { value: "WY", name: "Wyoming" },
];

export function onTimeChange(controlName: AbstractControl<any, any> | null) {
  const control = controlName
  if (control && control.value._d) {
    control.setValue(control.value.toISOString());
  }
}

export function getFileNameFromUrl(url:any) {
  if (url && url !== '') {
      const urlSegments = url.split('/');
      if (urlSegments)
          return decodeURI(urlSegments[urlSegments.length - 1]);
      else
          return '';
  } else {
      return '';
  }
}

export function uploadDocumentImages(documents: any, formControl: AbstractControl<any, any> | null, uploadService: UploadService, section:any ) {

  let selectedFile
  if (!(formControl instanceof FormControl)) {
      console.error('Invalid form control provided.');
      return;
  }

  imageProcessing(documents).subscribe({
      next: (result) => {
          selectedFile = result.file;
          if (!selectedFile || !(selectedFile instanceof Blob)) {
              console.error('Invalid file selected.');
              return;
          }

          uploadService.uploadImageToServer(selectedFile, section).subscribe({
              next: (uploadResult: any) => {
                  if (uploadResult.fileUrl) {
                      formControl.setValue(uploadResult.fileUrl);
                  } else {
                      console.error('Upload result does not contain a valid file URL.');
                  }
              },
              error: (uploadError:any) => {
                  console.error('Error uploading image:', uploadError);
              },
          });
      },
      error: (processingError:any) => {
          console.error('Error processing image:', processingError);
      },
  });
}

export const companyVerificationLabels = {
  isName: 'Name',
  isTimeZone: 'Time Zone',
  isWebURL: 'Web URL',
  isProfileImageURL: 'Company Logo',
  isPhoneNumber: 'Contact Number',
  isSecondaryPhoneNumber: 'Secondary Contact Number',
  isEmail: 'Email',
  isHoursofOperation: 'Hours of Operation',
  isServiceAreas: 'Service Area',
  isWebhookURL:'Web Hook URL',
  isCompanyRef:'Company Ref',
  address: {
    isName: 'Address',
    isCity: 'City',
    isState: 'State',
  },
  owner: {
    isFirstName: 'First Name',
    isMiddleName: 'Middle Name',
    isLastName: 'Last Name',
    isPhoneNumber: 'Owner Contact Number',
    isEmail: 'Owner Email',
    isDriverLicenseImage: "Driver's License",
    address: {
      isName: 'Owner Address',
      isCity: 'Owner City',
      isState: 'Owner State',
    },
  },
  documents: {
    isHIPAATrainingCertificateImage: 'HIPAA Training Certificate',
    isHIPAATrainingDate: 'HIPAA Training Completion Date',
    isHIPAATrainingExpireDate: 'HIPAA Training Expiration Date',
    isFraudWasteAndAbuseCertificateImage: 'Fraud, Waste and Abuse Training Certificate',
    isFraudWasteAndAbuseCertificateDate: 'Fraud, Waste and Abuse Training Completion Date',
    isFraudWasteAndAbuseCertificateExpireDate: 'Fraud, Waste and Abuse Training Expiration Date',
    isNonDisclosureAgreementImage: 'Signed Non-Disclosure Agreement',
    isTransportationProviderAgreementImage: 'Signed Transportation Provider Agreement',
    isW9Image: 'W-9 Form',
    isDisclosureofOwnershipImage: 'Disclosure of Ownership',
    isEFTFormImage: 'EFT Form',
    isVoidedCheckImage: 'Voided Check',
    isDriverScheduleImage: "Driver's Schedule",
    isVehicleScheduleImage: "Vehicle's Schedule",
    isVehicleForHireLicenseImage: 'Vehicle for Hire License',
  },
  insurance: {
    isGeneralLiabilityInsuranceImage: 'General Liability Insurance',
    isGeneralLiabilityInsuranceDate: 'General Liability Date',
    isGeneralLiabilityInsuranceExpireDate: 'General Liability Expiration Date',
    isAutoLiabilityInsuranceImage: 'Auto Liability Insurance',
    isAutoLiabilityInsuranceDate: 'Auto Liability Date',
    isAutoLiabilityInsuranceExpireDate: 'Auto Liability Expiration Date',
    isWorkerCOIImage: 'Worker COI',
    isWorkerCOIImageExpireDate: 'Worker COI Expiration Date',
  },
  bankDetails: {
    isName: 'Bank Name',
    isAccountNumber: 'Account Number',
    isRoutingNumber: 'Routing Number',
  },
  taxInformation: {
    isName: 'Name',
    isNpi: 'Npi',
    isTaxId: 'Tax Id',
    isTaxonomy: 'Taxonomy',
  },
  focalPersonInformation: {
    isName: 'Name',
    isEmail: 'Email',
    isContactNumber: 'Contact Number',
    isPhoneNumber: 'Phone Number',
  },
};

export const vehicleVerificationLabels = {
  isDescription: 'Name',
  isVin: 'VIN',
  isLicensePlateNumber: 'License Plate Number',
  isYear: 'Year',
  isMake: 'Make',
  isModel: 'Model',
  isColor: 'Color',
  isSpaceType: 'Space Type',
  garageAddress: {
    isName: 'Garage Address',
    isCity: 'City',
    isState: 'State',
  },
  isServiceAreas: 'Service Areas',
  images: {
    isRegistration: 'Registration',
    isInspectionReport: 'Inspection Report',
    isVehicle: ' Vehicle Image Front',
    isBack: 'Vehicle Image Back',
    isLeft: 'Vehicle Image Left',
    isRight: 'Vehicle Image Right',
  },
  dates: {
    isRegistrationDate: 'Registration Date',
    isRegistrationExpireDate: 'Registration Expiration Date',
    isInspectionDate: 'Inspection Date',
    isInspectionExpireDate: 'Inspection Expiration Date'
  },
};

export const driverVerificationLabels = {
  isFirstName: 'First Name',
  isMiddleName: 'Middle Name',
  isLastName: 'Last Name',
  isDisplayName: 'Display Name',
  isProfileImageURL: 'Profile Image',
  isSignature: 'Driver Signature',
  isPhoneNumber: 'Phone Number',
  isContactNumber: 'Contact Number',
  isEmail: 'Email',
  isDob: 'Date of Birth',
  isLanguageSpoken: 'Languages Spoken',
  address: {
    isName: 'Address',
    isCity: 'City',
    isState: 'State',
  },
  driverLicense: {
    isImage: "Front of Driver's License",
    isNumber: 'License Number',
    isIssueDate: 'License Issue Date',
    isExpireDate: 'License Expiration Date',
    isStateIssue: 'License State Issued',
  },
  examinations: {
    isPhyExamImage: 'Latest Physical Exam',
    isPhyExamDate: 'Latest Physical Exam Date',
    isPhyExamExpireDate: 'Latest Physical Exam Expiration Date',
    isDrugTestImage: 'Drug Test',
    isDrugTestDate: 'Drug Test Date',
    isDrugTestExpireDate: 'Drug Test Expiration Date',
  },
  isAbuse: 'Convicted of child abuse or felony',
  isViolations: 'Vehicle Violations',
  isServiceAreas: 'Service Areas',
  isAttestation: 'Attestation'

};

export function findServiceArea(zipCode:any, serviceAreas:any) {
  const serviceArea = serviceAreas.find((serviceArea:any) => serviceArea.zipCodes.includes(zipCode));
  return serviceArea ? serviceArea._id : "";
}

export function timeCalculation(trip:any, currentTime:any) {

  const end = moment(trip.scheduleTime);
  const startTime = moment(currentTime);
  const duration = moment.duration(end.diff(startTime));
  return duration.asMinutes();
}

export function phoneNumberLengthValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  const digitsOnly = control.value.replace(/\D/g, ''); // removes +, -, spaces, etc.
  if (digitsOnly.length < 10) {
    return { minlength: true };
  }
  if (digitsOnly.length > 13) {
    return { maxlength: true };
  }

  return null;
}


export function scrollToDocumentField(fieldKey: string, delay = 300, highlight = false, status: 'expired' | 'willExpire' = 'expired') {
  if (!fieldKey) return;
  setTimeout(() => {
    const target = document.getElementById(fieldKey)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (highlight) {
        const highlightClass = status === 'willExpire' ? 'field-highlight-soft' : 'field-highlight';
        target.classList.add(highlightClass);
        setTimeout(() => target.classList.remove(highlightClass), 3000);
      }
    }
  }, delay);
}

export function allowOnlyNumbersValidator(controlName: string): ValidatorFn {
  return (formGroup: AbstractControl): null => {
    const control = formGroup.get(controlName);
    if (!control) return null;
    let value: string = control.value || '';
    // Remove non-numeric characters
    const numericValue = value.replace(/[^0-9]/g, '');
    const trimmedNumericValue = numericValue.length > 13 ? numericValue.slice(0, 13) : numericValue;
    // Only update if value actually changed
    if (trimmedNumericValue !== value) {
      control.setValue(trimmedNumericValue, { emitEvent: false });
    }
    return null;
  };
}